import { HTMLAttributes, useEffect, useState } from 'react';
import { clearAction, updateAction } from '@/quote/util/update-action';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useStateMachine } from 'little-state-machine';

type QuoteDisclaimerProps = HTMLAttributes<HTMLDivElement>;
const QuoteDisclaimer = (props: QuoteDisclaimerProps) => {
  const { className } = props;
  const { state } = useStateMachine({
    updateAction,
    clearAction,
  });

  const { quote_disclaimer_enabled, quote_disclaimer_highlight_text, quote_disclaimer_content } = (state?.promotionInfo?.payload
    ?.quote_process_settings || {}) as any;
  return !!quote_disclaimer_enabled ? (
    <Box className={clsx('flex flex-col', className)}>
      <Typography className="text-xs font-bold leading-4 text-[#202020]">
        {quote_disclaimer_highlight_text ? quote_disclaimer_highlight_text + ' ' : ''}
        <span className="font-medium">{quote_disclaimer_content}</span>
      </Typography>
    </Box>
  ) : null;
};

export default QuoteDisclaimer;
